export function initializeTitleCatalogNavbar() {
  $('.block-title__menu li a[href^="#"]').click(function (e) {
    e.preventDefault();

    var target = $(this).attr("href");
    var offset = $(target).offset().top - $("header").height(); // Décalage pour prendre en compte le header

    $("html, body").animate(
      {
        scrollTop: offset,
      },
      500
    );
  });
}
